import { EventSection } from '@domain/event-section';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

interface EventSectionsParams {
  eventId?: string;
  options?: Record<string, boolean>;
}

export const createEventSectionsKey = (eventId: string | undefined) => {
  return [QUERY_KEYS.eventSections, eventId];
};

const getEventSections = async ({ eventId }: EventSectionsParams) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/events/${eventId}/sections`;

  const data: EventSection[] = await request({ url, method: RequestMethod.GET });

  return data.map((section) => ({
    ...section,
    items: [...section.items].sort((a, b) => a.position - b.position),
  }));
};

export const useGetEventSections = ({ eventId, options }: EventSectionsParams) => {
  return useGenericQuery<EventSection[], RequestError>(
    createEventSectionsKey(eventId),
    () => getEventSections({ eventId }),
    options
  );
};
